<template>
    <div class="ta_left">新浪理财大学重磅推出王者《碎片化创新语音课》干货提炼，交易日实盘语音精确实时指导，<a class="blue r-eid-adVipAudioTxt" :href="urlVipAudio">点击链接免费收听</a></div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    export default {
        name: 'txt-vip-audio',
        computed: {
            ...mapState('url', ['urlVipAudio'])
        }
    }
</script>
